module.exports = __webpack_public_path__ + "front/img/27_7.19929420.png";